import { FC } from 'react';
import { ProForm } from '../../antd';
import { BaseSimpleFormProps } from '../interface';

const SimpleFormItem: FC<BaseSimpleFormProps> = props => {
  const { children, ...restProps } = props;
  return <ProForm.Item {...restProps}>{children}</ProForm.Item>;
};

export default SimpleFormItem;
